<template lang="pug">
#modal-header-planilha
    el-dialog.modal-header-planilha-content(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        width='50%'
    )
        span(slot='title')
            h3
                b {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.titulo') }}

        .modal-header-planilha-content__container
            .container-header
                .container-header-table__infor
                    el-alert(
                        :title='alertDados.msg',
                        :type='alertDados.type',
                        show-icon,
                        :closable='false'
                    )

                div(v-if='temError')
                    .container-header-table
                        el-table(
                            v-if='usuarioLogado',
                            ref='tabelaDadosProcessadosRef',
                            :data='dadosPaginado',
                            style='width: 100%'
                        )
                            el-table-column(
                                :label='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.registro")'
                            )
                                template(slot-scope='scope') {{ (paginaAtual - 1) * pageCount + scope.$index + 1 }}

                            el-table-column(
                                :label='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.linha")'
                            )
                                template(slot-scope='scope') {{ scope.row.linha }}

                            el-table-column(
                                :label='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.campo")'
                            )
                                template(slot-scope='scope') {{ scope.row.campo }}

                            el-table-column(
                                :label='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.erro")'
                            )
                                template(slot-scope='scope') {{ scope.row.mensagem }}

                    .container-header-pagination
                        .spans-paginacao

                        el-pagination(
                            background,
                            :page-size='pageCount',
                            :pager-count='pageCount',
                            :current-page.sync='paginaAtual',
                            layout='prev, pager, next',
                            :total='dados.length',
                            @current-change='mudarPagina'
                        )
                div(v-else)
                    .container-header-table
                        h4
                            b {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.listaCarImportados') }}
                        el-table(
                            v-if='usuarioLogado',
                            ref='tabelaDadosProcessadosRef',
                            :data='dadosPaginado',
                            style='width: 100%'
                        )
                            el-table-column(
                                :label='$t("mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.documentoPY")'
                            )
                                template(slot-scope='scope') {{  usuarioLogado.ambienteLogado === 'PY' ? `${scope.row.$t("mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.documentoPY")}` : scope.row.CAR  }}

                            el-table-column(
                                :label='usuarioLogado.ambienteLogado === "PY" ? "RUC" : $t("mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.documento")'
                            )
                                template(slot-scope='scope') {{ usuarioLogado.ambienteLogado === 'PY' ? scope.row.RUC : formatarCpfCnpj(scope.row['CPF/CNPJ']) }}

                            el-table-column(
                                :label='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.volume")'
                            )
                                template(slot-scope='scope') {{ scope.row.Volume }}

                    .container-header-pagination
                        .spans-paginacao
                            span.pagina
                                | {{ dados.length }} {{ dados.length > 1 ? $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.imoveis') : $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.imovel') }}

                            span.volume
                                | {{ formatarTonelada(somarTonelada) }} {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.toneladas') }}

                        el-pagination(
                            background,
                            :page-size='pageCount',
                            :pager-count='pageCount',
                            :current-page.sync='paginaAtual',
                            layout='prev, pager, next',
                            :total='dados.length',
                            @current-change='mudarPagina'
                        )

        footer.my-3(slot='footer')
            .btn-voltar
                el-button(
                    @click='fecharModal',
                    v-if='!temError',
                    :disabled='carregando'
                )
                    |
                    | {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.Voltar') }}

            .btn-opcao
                div(v-if='temError')
                    el-button(type='primary', @click='fecharModal')
                        | {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.fechar') }}
                div(v-else)
                    el-button(
                        type='primary',
                        @click='analisarImoveis',
                        :loading='carregando',
                        :icon='carregando ? "el-icon-loading" : ""'
                    )
                        | {{ carregando ? '' : $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.analisarElegibilidade') }}
</template>

<script>
import formatters from '@/utils/formatters';
import { mapGetters } from 'vuex';

export default {
    name: 'ModalProcessamentoRastreabilidadeEmMassaPlanilha',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        dados: {
            type: Array,
            required: true
        },
        temError: {
            type: Boolean,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        }
    },

    data() {
        return {
            paginaAtual: 1,
            pageCount: 5,
            alertDados: {
                type: '',
                msg: ''
            }
        };
    },

    watch: {
        show: function () {
            if (!this.show) return;
            this.resetModal();
            if (this.temError) {
                this.alertDados = {
                    type: 'error',
                    msg: `${this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.identificado'
                    )} ( ${this.dados.length} ) ${this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.incosistenciaPreenchimento'
                    )}`
                };
            } else {
                this.alertDados = {
                    type: 'success',
                    msg: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.camposPreenchimento'
                    )
                };
            }
        }
    },

    computed: {
        ...mapGetters(['usuarioLogado']),
        dadosPaginado() {
            const inicio = (this.paginaAtual - 1) * this.pageCount;
            const fim = inicio + this.pageCount;

            return this.dados.slice(inicio, fim);
        },
        somarTonelada() {
            let soma = 0;
            this.dados.forEach(item => {
                const valor = item['Volume'].replace(',', '.');
                const numero = parseFloat(valor);
                if (!isNaN(numero)) {
                    soma += numero;
                }
            });
            return soma;
        }
    },

    methods: {
        resetModal() {
            this.paginaAtual = 1;
            this.alertDados = {
                type: '',
                msg: ''
            };
        },
        mudarPagina(currentPage) {
            this.paginaAtual = currentPage;
        },
        formatarCpfCnpj(valor) {
            if (
                /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(valor) ||
                /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/.test(valor)
            ) {
                return valor;
            } else {
                return formatters.numeralStringFormatTocpfCnpj(
                    valor.replace(/\D/g, '')
                );
            }
        },

        fecharModal() {
            try {
                this.$messageBox
                    .confirm(
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.confirmarModal'
                        ),
                        this.$t(
                            'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.avisos.aviso'
                        ),
                        {
                            confirmButtonText: this.$t(
                                'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.avisos.confirmar'
                            ),
                            cancelButtonText: this.$t(
                                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.cancelar'
                            ),
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        this.$emit('voltar');
                    })
                    .catch(() => {});
            } catch (erro) {}
        },
        async analisarImoveis() {
            // this.$emit('analisarImoveis');
            this.$emit('analisarImoveisBackground');
        },
        formatarTonelada(valor) {
            if (valor) {
                const valorString = valor.toString();
                const index = valorString.indexOf('.');
                if (index > -1) {
                    const qtdCasasDecimais = valorString.substring(
                        index + 1
                    ).length;
                    const casasDecimais = qtdCasasDecimais >= 3 ? 3 : 2;
                    return formatters.formatNumber(valor, casasDecimais);
                }
                return formatters.formatNumber(valor, 2);
            }
            return '-';
        }
    }
};
</script>

<style lang="scss">
#modal-header-planilha {
    footer {
        display: flex;
        justify-content: space-between;
    }
}
.modal-header-planilha-content {
    .el-dialog__header {
        padding: 20px;
        padding-bottom: 10px;
        background: var(--primary) !important;
        color: var(--white);
        padding-bottom: 12px;
        padding-top: 12px;
    }
    .el-dialog__body {
        padding: 20px 20px 30px 20px;
        word-break: break-word;
    }
    .el-dialog__headerbtn {
        top: 10px;
    }
    .el-dialog__headerbtn:hover .el-icon-close {
        color: #ffffff;
    }
    .modal-analise-elegibilidade--header {
        display: flex;
        align-items: center;
    }
    .container-header-table__infor {
        margin-bottom: 18px;

        .el-alert__title {
            color: #3b3b3b !important;
        }
    }
    .container-header-table {
        h4 {
            margin-bottom: 16px;
        }

        .el-table {
            border-top-right-radius: 11px;
            border-top-left-radius: 11px;
            min-height: 140px;

            thead.has-gutter {
                th.el-table__cell {
                    background-color: #fbfbfb;
                }
            }

            .descricao-item-tabela {
                margin-left: 55px;
                margin-right: 55px;
            }
            .el-table .cell .el-checkbox__inner {
                padding: 0px;
            }
        }
    }
    .container-header-pagination {
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .spans-paginacao {
            display: flex;
            gap: 21px;
            color: #183b57;
            font-weight: bold;
        }
    }

    .btn-opcao {
        .el-button {
            min-width: 153px;
        }
    }
}
</style>
